import { utils } from 'ethers';
import { ethAddress, suiAddress, tonAddress } from '@/config/address';
import { Buffer } from 'buffer';

export function isHexPrefixed(str: string): boolean {
  if (typeof str !== 'string') {
    throw new Error(
      `[isHexPrefixed] input must be type 'string', received type ${typeof str}`
    );
  }

  return str[0] === '0' && str[1] === 'x';
}

export const addHexPrefix = function (str: string): string {
  if (typeof str !== 'string') {
    return str;
  }

  return isHexPrefixed(str) ? str : '0x' + str;
};

export const isApp = () => {
  return /bybit_app/.test(navigator.userAgent.toLowerCase());
};

export const isBrowser = typeof window !== 'undefined';

export const isIOS = () => {
  return isBrowser && /iphone/.test(navigator.userAgent.toLowerCase());
};
export const getAddress = (
  address: string,
  opt: {
    // 地址有错时返回空字符串 ''， 默认是 返回原来的内容+0x,
    emptyWhenError?: boolean;
    // 大写还是小写，其它值是保持原样，默认是小写
    format?: 'low' | 'upper';
  } = {}
): string => {
  if (address === '') {
    return address;
  }
  let tmp = address;
  const { emptyWhenError = false, format = 'low' } = opt;

  try {
    tmp = utils.getAddress(address);
  } catch (error) {
    if (emptyWhenError) {
      return '';
    }
    tmp = addHexPrefix(address);
  }
  if (format === 'low') {
    return tmp.toLowerCase();
  }
  if (format === 'upper') {
    return tmp.toUpperCase();
  }
  return tmp;
  return '';
};

export const shortAddress = (
  address: string,
  mark = '...',
  hexPrefix = true
) => {
  if (!address) return '--';
  const addr = hexPrefix ? getAddress(address) : address;
  return addr.replace(/(.{6}).*(.{4})/, `$1${mark}$2`);
};

export const isNativeToken = (address: string) => {
  return (
    address === ethAddress || address === suiAddress || address === tonAddress
  );
};

export const ObjIsEmpty = (v: object) => {
  return Object.keys(v).length === 0;
};

function uint8ArrayToHex(array: Uint8Array): string {
  return Array.from(array)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export const base64ToHex = (base64: string) => {
  const arrayBuffer = Buffer.from(base64, 'base64');
  return uint8ArrayToHex(arrayBuffer);
};

export const shortenString = (str: string, mark = '...') => {
  if (!str) return '--';
  return str.replace(/(.{6}).*(.{4})/, `$1${mark}$2`);
};

/**
 * 判断是否为 Lombard 池子
 * @param poolId 池子 ID
 * @returns 是否为 Lombard 池子
 */
export const isLombardPool = (poolId?: number | string) => {
  return poolId === 100 || poolId === '100';
};

/**
 * 判断是否为 isLBTCvPool 池子
 * @param poolId 池子 ID
 * @returns 是否为 isLBTCvPool 池子
 */
export const isLBTCvPool = (poolId?: number | string) => {
  return poolId === 102 || poolId === '102';
};
